import { api, ApiRequestConfig } from '../../api';

type TFetchStores = {
	regionCode: string;
};

export const fetchStores = (url: string, params: TFetchStores, config?: ApiRequestConfig) =>
	api.get(url, params, config);

type TFetchInstoreCategories = {
	currentCategoryId?: string;
};

export const fetchInstoreCategories = (
	url: string,
	params: TFetchInstoreCategories,
	config?: ApiRequestConfig
) => api.get(url, params, config);
